import { observer } from 'mobx-react-lite'

import { ReactComponent as AddIcon } from 'assets/icons/plus16.svg'
import { Button } from 'components/Button'

import { useCollaborationDialog } from './CollaborationDialogStore'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import { useContext } from 'react'

export const CollaborationDialogAddButton = observer(function CollaborationDialogAddButton() {
  const almanacState = useContext(AlmanacEditorStateContext)
  const collaborationDialogStore = useCollaborationDialog()

  if (!almanacState?.isSelectedNodeCommentable) return null

  return (
    <Button
      preventFocusOnPress
      frontIcon={AddIcon}
      variant="none"
      size="md"
      onClick={(e) => {
        e.stopPropagation()
        collaborationDialogStore.openNewComment()
      }}
    />
  )
})
